module.exports = __webpack_public_path__ + "img/6.9d0996a6.svg";